export default __webpack_public_path__ + "static/media/guesty_lite_step1.0b15e352.png";